import { render, staticRenderFns } from "./AssignSlotModal.vue?vue&type=template&id=54b8c7f6&"
import script from "./AssignSlotModal.vue?vue&type=script&lang=js&"
export * from "./AssignSlotModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignSlotModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports